(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    // console.log({ entries })
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);
    const url = productRecommendationsSection.dataset.url;
    const target = productRecommendationsSection.querySelector('.content-container');

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelectorAll('.grid-item__content');
        console.log({ recommendations, html, target });

        if (recommendations.length > 0 && target) {
          const elem = document.createElement('custom-slider');
          elem.className = 'block';
          elem.innerHTML = `
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper">
              <div class="swiper-wrapper">
                ${[...recommendations].map(node => `<div class="product-grid-item swiper-slide">${node.outerHTML}</div>`).join('')}
              </div>
            </div>
          `;

          console.log({ elem });
          target.appendChild(elem);
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.js-recommendations-slider');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  // console.log({ productRecommendationsSection, observer });
  if (productRecommendationsSection) {
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
